import { lazy } from 'react';
import retry from './retry';

const lazyLoad = (fn) => lazy(() => retry(fn, 4, 2500));

export default lazyLoad;